import { c as _c } from "react/compiler-runtime";
import IconDiamond from '@/components/assets/icon_diamond.svg';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
export default function PremiumTag(t0) {
  const $ = _c(10);
  const {
    className
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== className) {
    t1 = cn("bg-vive-surface-normal/40 hover:bg-vive-surface-normal/40 max-w-fit cursor-default gap-1.5 rounded-[5px] px-2 py-1 backdrop-blur-md", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconDiamond className="size-[12px] fill-[#FF82FB]" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("premium-badge.label");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="bg-gradient-title-3 bg-clip-text text-transparent">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <Badge className={t1}>{t2}{t4}</Badge>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}